/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createE } from '../../factoriesAny.js';
export var eDependencies = {
  BigNumberDependencies,
  createE
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesE.generated.js
// module id = 9t3e
// module chunks = 3